import { css } from "@emotion/css";

export function getStatusIconStyles(color?: string) {
    return css({
        width: 20,
        height: 20,
        fill: color || "currentcolor",
        display: "block",
    });
}
